import dayjs from 'dayjs'
import { jwtDecode } from 'jwt-decode'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import { sendReportMail } from '../store/builders/reports/reports.builder'
import jsPDF from 'jspdf'
import AdminLogo from '../assets/logo/admin-logo-img.png'
import { setMailLoading } from '../store/slice/reports/reports.slice'
// export const setUser = (token) => {
//   localStorage.setItem('token', JSON.stringify(token))
// }

// export const getUser = () => (localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : '')

// genricFunction.js
export const getToken = () => {
  const token = localStorage.getItem('token')
  return token ? JSON.parse(token) : null
}

export const setToken = (token) => {
  localStorage.setItem('token', JSON.stringify(token))
}

export const removeUserSession = (dispatch) => {
  localStorage.removeItem('token')
  dispatch({ type: 'auth/clearExtraReducers' }) // Clear extra reducer
  dispatch({ type: 'branch/clearExtraReducers' })
  dispatch({ type: 'course/clearExtraReducers' })
  dispatch({ type: 'followup/clearExtraReducers' })
  dispatch({ type: 'inquiry/clearExtraReducers' })
  dispatch({ type: 'exam/clearExtraReducers' })
  dispatch({ type: 'practice/clearExtraReducers' })
  dispatch({ type: 'masterDataSet/clearExtraReducers' })
}

export const isTokenExpired = (token) => {
  const decodedToken = jwtDecode(token)
  const currentTime = Date.now() / 1000
  return decodedToken.exp < currentTime
}

export function convertDateFormatCalendar(dateStr) {
  if (dateStr) {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const [day, month, year] = dateStr?.split('/')
    const paddedDay = day?.length === 1 ? '0' + day : day
    const paddedMonth = month?.length === 1 ? '0' + month : month
    const isoDateString = `${year}-${paddedMonth}-${paddedDay}T00:00:00.000Z`
    return isoDateString
  }
}

export function convertBirthDateFormatCalendar(dateStr) {
  if (dateStr) {
    const [day, month, year] = dateStr.split('/')
    const paddedDay = day.length === 1 ? '0' + day : day
    const paddedMonth = month.length === 1 ? '0' + month : month
    const inputDate = new Date(`${year}-${paddedMonth}-${paddedDay}T00:00:00.000Z`)

    const currentDate = new Date()
    const fifteenYearsAgo = new Date()
    fifteenYearsAgo.setFullYear(currentDate.getFullYear() - 15)

    if (inputDate > currentDate) {
      alert('The date cannot be in the future.')
      return ''
    } else if (inputDate > fifteenYearsAgo) {
      alert('Age must be at least 15 years.')
      return ''
    }

    return inputDate.toISOString()
  }
}

export const DMYdateFormate = (date) => {
  const formattedDate = dayjs('2024-05-25').format('DD-MM-YYYY')
  return formattedDate
}

export function convertDateFormat(apiDate) {
  const date = new Date(apiDate)
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()
  return `${day}/${month}/${year}`
}

export const handleInput = (e) => {
  let value = e.target.value
  if (value.startsWith(' ')) {
    value = value.trimStart()
  }
  value = value.replace(/[^0-9]/g, '')
  e.target.value = value
}
export const handlePercentageInput = (e) => {
  let value = e.target.value.trimStart() // Remove leading spaces

  // Remove invalid characters
  value = value.replace(/[^0-9.]/g, '')

  // Handle multiple dots
  const dotIndex = value.indexOf('.')
  if (dotIndex !== -1) {
    value = value.substring(0, dotIndex + 1) + value.substring(dotIndex + 1).replace(/\./g, '')
  }

  // Check if value is a valid number
  const numericValue = parseFloat(value)

  // If value is not a number or exceeds 100, trim the value accordingly
  if (isNaN(numericValue)) {
    value = ''
  } else if (numericValue > 100) {
    value = '100'
  } else {
    // Limit to two decimal places
    const parts = value.split('.')
    if (parts.length === 2 && parts[1].length > 2) {
      parts[1] = parts[1].substring(0, 2)
      value = parts.join('.')
    }
  }

  e.target.value = value
}

export const handleInputString = (e) => {
  let value = e.target.value

  if (value.startsWith(' ')) {
    value = value.trimStart()
  }
  value = value.replace(/[0-9]/g, '').replace(/\s{2,}/g, ' ')
  e.target.value = value
}

export const handleInputStringWithNum = (e) => {
  let value = e.target.value

  if (value.startsWith(' ')) {
    value = value.trimStart()
  }
  value = value.replace(/\s{2,}/g, ' ')
  value = value.replace(/[^\w\s0-9-_]/gi, '')

  e.target.value = value
}

export const handleName = (e) => {
  let value = e.target.value

  if (value.startsWith(' ')) {
    value = value.trimStart()
  }
  value = value.replace(/[0-9]/g, '')
  value = value.replace(/\s{2,}/g, ' ')
  value = value.replace(/[^\w\s]/gi, '')

  e.target.value = value
}

export const handleInputStringNoSpace = (e) => {
  let value = e.target.value
  value = value.replace(/\s/g, '').replace(/[0-9]/g, '')
  e.target.value = value
}

export const handleInputAddress = (e) => {
  let value = e.target.value
  value = value.trimStart()
  value = value.replace(/\s+/g, ' ')

  e.target.value = value
}

export const handleEmail = (e) => {
  let value = e.target.value
  if (value.startsWith(' ')) {
    value = value.trimStart()
  }
  value = value.replace(/\s/g, '')
  value = value.replace(/[^\w@.-]/g, '')

  e.target.value = value
}

export const handlePassword = (e) => {
  let value = e.target.value
  value = value.replace(/\s/g, '')
  e.target.value = value
}

export const formatDateToUTC = (date) => {
  if (!(date instanceof Date)) {
    throw new TypeError('Invalid date argument. Please provide a valid Date object.')
  }

  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0') // Add 1 for zero-based indexing
  const year = date.getUTCFullYear()

  return `${day}/${month}/${year}` // YYYY-MM-DD format (common and machine-readable)
}

export const capitalizeFirstLetter = (data) => {
  return data?.charAt(0)?.toUpperCase() + data?.slice(1)
}

export function dayAndDate(dateString) {
  const date = new Date(dateString)

  const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

  const dayOfWeek = weekdays[date.getUTCDay()]
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0') // Months are 0-based in JS
  const year = date.getUTCFullYear()

  const currentDate = new Date()
  const currentDay = String(currentDate.getUTCDate()).padStart(2, '0')
  const currentMonth = String(currentDate.getUTCMonth() + 1).padStart(2, '0')
  const currentYear = currentDate.getUTCFullYear()

  const isToday = day === currentDay && month === currentMonth && year === currentYear

  const dayAndDate = isToday ? `Today, ${day}/${month}/${year}` : `${dayOfWeek}, ${day}/${month}/${year}`
  return dayAndDate
}

export const generateDropdownOptions = (array, label, value) => {
  return array?.length > 0
    ? array?.map((item) => {
        return {
          label: capitalizeFirstLetter(item[label]),
          value: item[value],
        }
      })
    : []
}

export const generateDropdownOptionsWithoutArchive = (array, label, value, archiveStatus) => {
  return array
    ?.filter((item) => item[archiveStatus] !== 'archive')
    .map((item) => {
      return {
        label: capitalizeFirstLetter(item[label]),
        value: item[value],
      }
    })
}

export const capitalizeAllLetter = (string) => {
  return string?.replace(/_/g, ' ')?.toUpperCase()
}

export const formatDate = (isoString) => {
  const date = new Date(isoString)

  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
    hour12: false,
  }

  return date.toLocaleString('en-US', options)
}

export function convertTZToDate(tzString) {
  // Create a new Date object from the TZ string
  const date = new Date(tzString)

  // Extract the day, month, and year from the Date object
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
  const year = date.getFullYear()

  // Return the date in dd/mm/yyyy format
  return `${day}/${month}/${year}`
}

const loginPermission = [
  'ADMIN_DASHBOARD',
  'LIST_COURSE',
  'ADD_COURSE',
  'ASSIGN_TO_BRANCH',
  'EDIT_COURSE',
  'ARCHIVE_COURSE',
  'LIST_INQUIRY',
  'ADD_INQUIRY',
  'MOVE_TO_WALKIN',
  'TAKE_FOLLOW_UP',
  'EDIT_INQUIRY',
  'ARCHIVE_INQUIRY',
  'ENROLL_INQUIRY',
  'LIST_BRANCH',
  'ADD_BRANCH',
  'MANAGE_CLASSROOM',
  'MANAGE_BATCH',
  'EDIT_BRANCH',
  'ARCHIVE_BRANCH',
  'LIST_FACULTY',
  'ADD_FACULTY',
  'BILLING_INFO',
  'BILLING_HISTORY',
  'EDIT_FACULTY',
  'ARCHIVE_FACULTY',
  'LIST_ENROLLMENT',
  'TRANSFER_BATCH_OR_BRANCH',
  'EDIT_ENROLLMENT',
  'ARCHIVE_ENROLLMENT',
  'LIST_TIMETABLE',
  'FILTER_TIMETABLE',
  'ADD_TIMETABLE',
  'EDIT_TIMETABLE',
  'LIST_INVENTORY',
  'ADD_INVENTORY',
  'ADD_INVENTORY_TO_BRANCH',
  'EDIT_INVENTORY',
  'INVENTORY_HISTORY',
  'VIEW_REPORTS',
  'VIEW_PLACEMENTS',
  'LIST_ROLE',
  'ADD_ROLE',
  'EDIT_ROLE',
  'LIST_USER',
  'ADD_USER',
  'EDIT_USER',
  'VIEW_STUDENT_PROFILE',
  'VIEW_STUDENT_FEES',
  'VIEW_STUDENT_EXAM',
  'VIEW_FACULTY_EXAM_ASSESSMENT',
  'VIEW_FACULTY_PROFILE',
]

export function checkPermissions(permissionCode) {
  return loginPermission.includes(permissionCode) ? true : false
}

export function formatDateToUTCString(dateObject) {
  // Assuming dateObject is in local time zone

  //2024-07-01T00:00:00.000Z
  // 2024-07-01T09:26:26.010Z

  // var formattedDate = dateObject.toISOString().split('T')[0] + 'T00:00:00.000Z'
  var formattedDate = dateObject.toISOString()
  return formattedDate
}

export function getInitials(name) {
  if (name) {
    const [first, second] = name.split(' ')
    return (first[0] + (second ? second[0] : ''))?.toUpperCase()
  }
}

export function roundDownToHour(timeStr) {
  const [time, period] = timeStr.split(' ')
  const [hour] = time.split(':')
  return `${hour.padStart(2, '0')}:00 ${period}`
}

export function convertDate(dateStr) {
  const [day, month, year] = dateStr.split('/')
  return `${year}-${month}-${day}`
}

export const handleInventory = (e) => {
  let value = e.target.value

  if (value.startsWith(' ')) {
    value = value.trimStart()
  }

  // Remove numbers and special characters, replace multiple spaces with a single space
  value = value
    .replace(/[0-9]/g, '')
    .replace(/[!@#$%^&*(),.?":{}|<>]/g, '')
    .replace(/\s{2,}/g, ' ')

  e.target.value = value
}

export const dynamicCustomFilter = (value, filter, matchMode) => {
  if (value === null || value === undefined || filter === null || filter === undefined) {
    return false
  }

  const valueStr = typeof value === 'number' ? value.toString() : value.toLowerCase()
  const filterStr = filter.toLowerCase().trim()

  switch (matchMode) {
    case 'STARTSWITH':
      return valueStr.startsWith(filterStr)
    case 'CONTAINS':
      return valueStr.includes(filterStr)
    case 'EQUALS':
      return valueStr === filterStr
    case 'GREATERTHAN':
      return typeof value === 'number' && !isNaN(value) && !isNaN(filter) && value > Number(filter)
    case 'LESSTHAN':
      return typeof value === 'number' && !isNaN(value) && !isNaN(filter) && value < Number(filter)
    case 'MATCHES':
      return new RegExp(filter).test(valueStr)
    default:
      return false
  }
}

export const addIdKeyToObject = (dataArray) => {
  return dataArray?.length > 0
    ? dataArray?.map((data, index) => {
        return {
          id: index + 1,
          ...data,
        }
      })
    : []
}

/**
 * Export data to Excel.
 * @param {Array} data - The data to be exported.
 * @param {Array} headers - The column headers for the table.
 * @param {String} sheetName - The name of the Excel sheet.
 * @param {String} fileName - The name of the Excel file.
 */

export const exportKitDistributionReport = (data, headers, sheetName = 'Sheet1', fileName = 'Report.xlsx') => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  let rowIndex = 1

  // Define a helper function to set column widths
  const setColumnWidths = () => {
    headers?.forEach((header, index) => {
      const width =
        header.style && header.style.minWidth ? parseInt(header.style.minWidth.replace('rem', '')) * 1.5 : 20
      worksheet.getColumn(index + 1).width = width
    })
  }

  const calculateRowHeight = (row) => {
    let maxLines = 1
    row.eachCell((cell) => {
      const cellLines = cell.value.toString().split('\n').length
      if (cellLines > maxLines) {
        maxLines = cellLines
      }
    })
    return maxLines * 20
  }

  // Define a helper function to apply styles to cells
  const applyCellStyles = () => {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center' }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
      })
      row.height = 25
    })
  }

  // Add table header row
  const headerRow = worksheet.addRow(headers.map((header) => header.header))
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    cell.border = {
      top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
    }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '000000' }, // Black background
    }
  })
  headerRow.height = calculateRowHeight(headerRow)

  // Add data rows
  data.forEach((item) => {
    const dataRow = worksheet.addRow(headers.map((header) => item[header.field]))
    dataRow.alignment = { vertical: 'middle', horizontal: 'center' }
    rowIndex++
  })

  setColumnWidths()
  applyCellStyles()

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/octet-stream' })
    saveAs(blob, fileName)
  })
}

export const exportTimeTableReport = async (
  timetables,
  headers,
  sheetName = 'Sheet1',
  fileName = 'Report.xlsx',
  type,
  dispatch,
  email,
  mailPayload,
) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)
  let rowIndex = 1

  const setColumnWidths = () => {
    headers.forEach((header, index) => {
      const width =
        header.style && header.style.minWidth ? parseInt(header.style.minWidth.replace('rem', '')) * 1.5 : 20
      worksheet.getColumn(index + 1).width = width
    })
  }

  const applyCellStyles = (startRow, endRow) => {
    for (let i = startRow; i <= endRow; i++) {
      const row = worksheet.getRow(i)
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
      })
    }
  }

  const formatCellValue = (value) => {
    const parts = value.split('\n')
    return parts.map((part) => {
      if (part === 'Online Exam') {
        return { text: `${part}\n`, font: { color: { argb: 'FF00FF00' } } } // green color
      }
      if (part === 'Offline Exam') {
        return { text: `${part}\n`, font: { color: { argb: 'FFFF0000' } } } // Red color
      }

      return { text: `${part}\n` }
    })
  }

  const calculateRowHeight = (row) => {
    let maxLines = 1
    row.eachCell({ includeEmpty: true }, (cell) => {
      const cellLines = cell.value ? cell.value.toString().split('\n').length : 1
      if (cellLines > maxLines) {
        maxLines = cellLines
      }
    })
    return maxLines * 20 // Adjust as needed based on your text size and row height requirements
  }

  timetables.forEach((timetable) => {
    const classTimeRow = worksheet.addRow([timetable.classTime])
    classTimeRow.eachCell((cell) => {
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 14 }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '999999' },
      }
    })
    worksheet.mergeCells(`A${rowIndex}:H${rowIndex}`)
    classTimeRow.height = 40
    rowIndex++

    const headerRow = worksheet.addRow(headers.map((header, index) => header.header[index].join('\n')))
    headerRow.eachCell((cell) => {
      cell.font = { bold: true }
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      cell.border = {
        top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      }
    })
    headerRow.height = calculateRowHeight(headerRow)
    rowIndex++

    timetable.data.forEach((item) => {
      const rowData = headers.map((header) => {
        const rawValue = item[header.field] || ''
        return { richText: formatCellValue(rawValue) }
      })
      const dataRow = worksheet.addRow(rowData)
      dataRow.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      })
      dataRow.height = calculateRowHeight(dataRow)
      rowIndex++
    })

    applyCellStyles(rowIndex - timetable.data.length - 1, rowIndex - 1)
    worksheet.addRow([])
    rowIndex++
  })

  setColumnWidths()

  if (type === 'Export') {
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      saveAs(blob, fileName)
    })
  } else if (type === 'Mail') {
    dispatch(setMailLoading(true))
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      dispatch(sendReportMail({ blob, emailData: email.join(), type: 'timetable', data: mailPayload }))
        .unwrap()
        .finally(() => {
          dispatch(setMailLoading(false))
        })
    })
  }
}

export const exportTableWithFooter = (data, headers, footers, sheetName = 'Sheet1', fileName = 'Report.xlsx') => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  let rowIndex = 1

  // Define a helper function to set column widths
  const setColumnWidths = () => {
    headers?.forEach((header, index) => {
      const width =
        header.style && header.style.minWidth ? parseInt(header.style.minWidth.replace('rem', '')) * 1.5 : 20
      worksheet.getColumn(index + 1).width = width
    })
  }

  const calculateRowHeight = (row) => {
    let maxLines = 1
    row.eachCell((cell) => {
      const cellLines = cell.value.toString().split('\n').length
      if (cellLines > maxLines) {
        maxLines = cellLines
      }
    })
    return maxLines * 20
  }

  const applyCellStyles = () => {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center' }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
      })
      row.height = 25
    })
  }

  const headerRow = worksheet.addRow(headers.map((header) => header.header))
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    cell.border = {
      top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
    }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '999999' },
    }
  })
  headerRow.height = calculateRowHeight(headerRow)

  data.forEach((item) => {
    const dataRow = worksheet.addRow(headers.map((header) => item[header.field]))
    dataRow.alignment = { vertical: 'middle', horizontal: 'center' }
    rowIndex++
  })

  if (footers && footers.length > 0) {
    const footerRow = worksheet.addRow(footers)
    footerRow.eachCell((cell) => {
      cell.font = { bold: true }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'f9fafb' },
      }
    })

    worksheet.mergeCells(`A${footerRow.number}:B${footerRow.number}`)
    worksheet.getCell(`A${footerRow.number}`).value = 'Total'
    footerRow.height = calculateRowHeight(footerRow)
  }

  setColumnWidths()
  applyCellStyles()

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/octet-stream' })
    saveAs(blob, fileName)
  })
}

const dailyReportDateFormatter = (date) => {
  return dayjs(date).format('DD-MM-YYYY')
}

export const exportDailyReport = (tables, sheetName = 'Sheet1', fileName = 'Report.xlsx', type, dispatch, email) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  const calculateRowHeight = (row) => {
    let maxLines = 1
    row.eachCell((cell) => {
      const cellLines = cell.value.toString().split('\n').length
      if (cellLines > maxLines) {
        maxLines = cellLines
      }
    })
    return maxLines * 20
  }

  let rowIndex = 1
  const columnWidths = new Map()

  const calculateColumnWidth = (cellValue, columnIndex) => {
    // Update the width for the given column based on cell content length
    const currentWidth = columnWidths.get(columnIndex) || 10 // default width
    const cellLength = cellValue ? cellValue.toString().length : 0
    columnWidths.set(columnIndex, Math.max(currentWidth, cellLength))
  }

  const setColumnWidths = () => {
    columnWidths.forEach((width, columnIndex) => {
      worksheet.getColumn(columnIndex + 1).width = width + 2 // Add some padding
    })
  }

  const applyCellStyles = () => {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
      })
      row.height = 25
    })
  }

  tables.forEach((table, tableIndex) => {
    const { headers, data, footers, title } = table

    if (title) {
      const headerRow = worksheet.addRow([title])
      headerRow.eachCell((cell, index) => {
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        cell.border = {
          top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
          right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '999999' },
        }
      })
      headerRow.height = calculateRowHeight(headerRow)
      switch (tableIndex) {
        case 0:
          worksheet.mergeCells(`A${rowIndex}:H${rowIndex}`)
          break
        case 1:
          worksheet.mergeCells(`A${rowIndex}:D${rowIndex}`)
          break
        default:
          worksheet.mergeCells(`A${rowIndex}:E${rowIndex}`)
      }
    }

    const headerRow = worksheet.addRow(headers.map((header) => header.header))
    headerRow.eachCell((cell, index) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }
      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      cell.border = {
        top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
        right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '999999' },
      }
      calculateColumnWidth(cell.value, index)
    })
    headerRow.height = calculateRowHeight(headerRow)
    rowIndex++

    if (data.length === 0) {
      const noDataRow = worksheet.addRow(['No Data Found'])
      noDataRow.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center' }
      })
      worksheet.mergeCells(`A${noDataRow.number}:${String.fromCharCode(64 + headers.length)}${noDataRow.number}`)
      rowIndex++
    } else {
      // Add data rows
      data.forEach((item) => {
        const formattedData = headers.map((header) => {
          if (header.dataType === 'date' && item[header.field] && dayjs(item[header.field]).isValid()) {
            // Format only date fields
            return dailyReportDateFormatter(item[header.field])
          }
          return item[header.field]
        })
        const dataRow = worksheet.addRow(formattedData)
        dataRow.eachCell((cell, index) => {
          calculateColumnWidth(cell.value, index)
        })
        dataRow.alignment = { vertical: 'middle', horizontal: 'center' }
        rowIndex++
      })
      if (footers && footers.length > 0) {
        // Dynamically calculate totals for specific headers
        const totals = headers.reduce((acc, header) => {
          if (header.field === 'telephoniccount' || header.field === 'walkincount') {
            acc[header.field] = data.reduce((sum, item) => sum + (Number(item[header.field]) || 0), 0)
          }
          return acc
        }, {})

        // Prepare footer row with dynamic totals for the specific headers
        const footerRowValues = headers.map((header, index) => {
          if (index === 0) return 'Total' // Add 'Total' label in the first column
          if (totals[header.field] !== undefined) return totals[header.field] // Insert total for specific headers
          return '' // Leave other fields blank
        })

        // Add the footer row to the worksheet
        const footerRow = worksheet.addRow(footerRowValues)
        footerRow.eachCell((cell, index) => {
          cell.font = { bold: true }
          cell.alignment = { vertical: 'middle', horizontal: 'center' }
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          }
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f9fafb' },
          }
          calculateColumnWidth(cell.value, index)
        })

        // Merge cells for the "Total" label
        worksheet.mergeCells(`A${footerRow.number}:B${footerRow.number}`)
        worksheet.getCell(`A${footerRow.number}`).value = 'Total'

        // Adjust row height
        footerRow.height = calculateRowHeight(footerRow)
        rowIndex++
      }
    }

    rowIndex++ // Add an extra row as a spacer between tables
  })

  setColumnWidths()
  applyCellStyles()

  if (type === 'Export') {
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      saveAs(blob, fileName)
    })
  }

  if (type === 'Mail') {
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      dispatch(
        sendReportMail({
          blob,
          emailData: [email, 'hardik.s@unisonglobus.com', 'jigar@finacchub.com'],
        }),
      )
    })
  }
}

export const exportAreaWiseInquiryReport = (data, sheetName = 'Sheet1', fileName = 'InquiryReport.xlsx') => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  // Helper function to set column widths
  const setColumnWidths = () => {
    const columns = worksheet.columns
    columns.forEach((column) => {
      let maxLength = 0
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 10
        if (columnLength > maxLength) {
          maxLength = columnLength
        }
      })
      column.width = maxLength + 2
    })
  }

  // Helper function to apply styles to cells
  const applyCellStyles = () => {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
      })
    })
  }

  // Add headers
  const headers = [
    'City',
    'Area',
    'Telephonic Alive',
    'Telephonic Dead',
    'Telephonic Total',
    'Walkin Alive',
    'Walkin Dead',
    'Walkin Total',
    'Enroll Alive',
    'Enroll Dead',
    'Enroll Total',
    'Total Count',
  ]
  worksheet.addRow(headers).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } } // White font color
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '999999' }, // Gray background
      bgColor: { argb: 'FFFFFFFF' }, // White background
    }
  })

  // Add data rows
  data.inquiry.forEach((item) => {
    const rowData = [
      item.permanent_city,
      item.permanent_area,
      item.telephonic_alive_count,
      item.telephonic_dead_count,
      item.telephonic_count,
      item.walkin_alive_count,
      item.walkin_dead_count,
      item.walkin_count,
      item.enroll_alive_count,
      item.enroll_dead_count,
      item.enroll_count,
      item.total_count,
    ]
    worksheet.addRow(rowData)
  })

  // Add total row
  const totalCounts = data.totalCounts
  const totalRow = [
    'Total',
    '',
    totalCounts.telephonic_alive_count,
    totalCounts.telephonic_dead_count,
    totalCounts.telephonic_count,
    totalCounts.walkin_alive_count,
    totalCounts.walkin_dead_count,
    totalCounts.walkin_count,
    totalCounts.enroll_alive_count,
    totalCounts.enroll_dead_count,
    totalCounts.enroll_count,
    totalCounts.total_count,
  ]
  const totalRowRef = worksheet.addRow(totalRow)

  // Merge cells for the "Total" label to span two columns
  worksheet.mergeCells(totalRowRef.number, 1, totalRowRef.number, 2)
  const totalCell = worksheet.getCell(totalRowRef.number, 1)
  totalCell.font = { bold: true, color: { argb: 'FFFFFFFF' } } // White font color
  totalCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
  totalCell.border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  }
  totalCell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '999999' }, // Gray background
    bgColor: { argb: 'FFFFFFFF' }, // White background
  }

  setColumnWidths()
  applyCellStyles()

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/octet-stream' })
    saveAs(blob, fileName)
  })
}

////////////////

/**
 * Export data to Excel.
 * @param {Array} data - The data to be exported.
 * @param {Array} headers - The column headers for the table.
 * @param {String} sheetName - The name of the Excel sheet.
 * @param {String} fileName - The name of the Excel file.
 */
export const exportToExcel = (data, headers, sheetName = 'Sheet1', fileName = 'Report.xlsx') => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  let rowIndex = 1

  // Define a helper function to set column widths
  const setColumnWidths = () => {
    headers.forEach((header, index) => {
      const width =
        header.style && header.style.minWidth ? parseInt(header.style.minWidth.replace('rem', '')) * 1.5 : 15
      worksheet.getColumn(index + 1).width = width
    })
  }

  // Define a helper function to apply styles to cells
  const applyCellStyles = () => {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
      })
      row.height = 25
    })
  }

  // Helper function to convert date to desired format
  const convertToDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  // Loop through the data
  data.forEach((faculty) => {
    // Add faculty name row
    const facultyRow = worksheet.addRow([faculty.facultyName])
    facultyRow.eachCell((cell) => {
      cell.font = { bold: true, size: 14 }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
      worksheet.mergeCells(`A${rowIndex}:${String.fromCharCode(64 + headers.length)}${rowIndex}`)
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'CCCCCC' },
      }
    })

    rowIndex++

    // Add table header row
    const headerRow = worksheet.addRow(headers.map((header) => header.header))
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } } // White bold text
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '000000' }, // Black background color
      }
    })
    rowIndex++

    // Add data rows
    faculty.data.forEach((item) => {
      const dataRow = worksheet.addRow(
        headers.map((header) => {
          if (header.field === 'date') {
            return convertToDate(item[header.field])
          }
          return item[header.field]
        }),
      )
      dataRow.alignment = { vertical: 'middle', horizontal: 'center' }
      rowIndex++
    })

    // Add a blank row for spacing
    worksheet.addRow([])
    rowIndex++
  })

  // Set column widths
  setColumnWidths()

  // Apply styles to all cells
  applyCellStyles()

  // Generate Excel file and prompt download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/octet-stream' })
    saveAs(blob, fileName)
  })
}

/**
 * Export data to Excel.
 * @param {Array} data - The data to be exported.
 * @param {Array} headers - The column headers for the table.
 * @param {String} sheetName - The name of the Excel sheet.
 * @param {String} fileName - The name of the Excel file.
 */

export const exportStudentReport = (data, sheetName = 'Sheet1', fileName = 'Report.xlsx') => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  // Define headers
  const headers = [
    { header: 'No', field: 'no', style: { minWidth: '12rem' } },
    { header: 'Code', field: 'studentCode', style: { minWidth: '12rem' } },
    { header: 'Student Name', field: 'studentName', style: { minWidth: '12rem' } },
    { header: 'Reg. Date', field: 'enrollmentDate', style: { minWidth: '12rem' } },
    { header: 'Birth Date', field: 'birthDate', style: { minWidth: '12rem' } },
    { header: 'Phone', field: 'studentPhone', style: { minWidth: '12rem' } },
    { header: 'Parent Phone', field: 'parentPhone', style: { minWidth: '12rem' } },
    { header: 'Email ID', field: 'email', style: { minWidth: '16rem' } },
    { header: 'Total Fees', field: 'totalFees', style: { minWidth: '12rem' } },
    { header: 'Paid', field: 'paidAmount', style: { minWidth: '12rem' } },
    { header: 'Pending', field: 'pendingAmount', style: { minWidth: '12rem' } },
  ]

  // Define a helper function to set column widths
  const setColumnWidths = () => {
    headers?.forEach((header, index) => {
      const width =
        header.style && header.style.minWidth ? parseInt(header.style.minWidth.replace('rem', '')) * 1.5 : 15
      worksheet.getColumn(index + 1).width = width
    })
  }

  // Define a helper function to apply styles to cells
  const applyCellStyles = () => {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
      })
      // Set the row height to simulate padding
      row.height = 25 // Adjust this value as needed
    })
  }

  // Helper function to format date to DD-MM-YYYY
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  // Add table header row
  const headerRow = worksheet.addRow(headers.map((header) => header.header))

  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } } // White bold text
    cell.alignment = { vertical: 'middle', horizontal: 'center' }
    cell.border = {
      top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
    }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '000000' }, // Black background
    }
  })

  // Add data rows
  data.forEach((item) => {
    const rowData = headers.map((header) => {
      if (header.field === 'enrollmentDate' || header.field === 'birthDate') {
        return formatDate(item[header.field])
      }
      return item[header.field]
    })
    const dataRow = worksheet.addRow(rowData)
    dataRow.alignment = { vertical: 'middle', horizontal: 'center' }
  })

  setColumnWidths()
  applyCellStyles()

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/octet-stream' })
    saveAs(blob, fileName)
  })
}

export const exportExamResultReport = (data, headers, sheetName = 'Sheet1', fileName = 'Report.xlsx') => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  // Define a helper function to set column widths
  const setColumnWidths = () => {
    headers?.forEach((header, index) => {
      const width =
        header.style && header.style.minWidth ? parseInt(header.style.minWidth.replace('rem', '')) * 1.5 : 15
      worksheet.getColumn(index + 1).width = width
    })
  }

  // Define a helper function to apply styles to cells
  const applyCellStyles = () => {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
      })
      // Set the row height to simulate padding
      row.height = 25 // Adjust this value as needed
    })
  }

  // Helper function to format date to DD-MM-YYYY
  const formatDate = (dateString) => {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  // Add table header row
  const headerRow = worksheet.addRow(headers.map((header) => header.header))

  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } } // White bold text
    cell.alignment = { vertical: 'middle', horizontal: 'center' }
    cell.border = {
      top: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      left: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      bottom: { style: 'thin', color: { argb: 'FFFFFFFF' } },
      right: { style: 'thin', color: { argb: 'FFFFFFFF' } },
    }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '000000' }, // Black background
    }
  })

  // Add data rows
  data.forEach((item) => {
    const rowData = headers.map((header) => {
      if (header.field === 'enrollmentDate' || header.field === 'birthDate') {
        return formatDate(item[header.field])
      }
      return item[header.field]
    })
    const dataRow = worksheet.addRow(rowData)
    dataRow.alignment = { vertical: 'middle', horizontal: 'center' }
  })

  setColumnWidths()
  applyCellStyles()

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/octet-stream' })
    saveAs(blob, fileName)
  })
}

export const convertToReportDate = (tzString) => {
  const date = new Date(tzString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
  const year = date.getFullYear()

  return `${year}-${month}-${day}`
}

export function addSequentialNo(facultyReport) {
  facultyReport.forEach((faculty) => {
    faculty.data.forEach((lecture, index) => {
      lecture.no = index + 1
    })
  })
  return facultyReport
}

export const attendanceReportToExcel = (attendanceData, dates, sheetName = 'Sheet1', fileName = 'Report.xlsx') => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  let rowIndex = 1

  // Define headers
  const headers = [
    { header: 'No', field: 'no', style: { minWidth: '2rem' } },
    { header: 'Code', field: 'student_code', style: { minWidth: '12rem' } },
    { header: 'Student Name', field: 'student_name', style: { minWidth: '12rem' } },
    ...dates.map((date) => ({
      header: convertToDate(date.toISOString().split('T')[0]),
      field: date.toISOString().split('T')[0],
    })),
  ]

  // Define a helper function to set column widths
  const setColumnWidths = () => {
    headers.forEach((header, index) => {
      const width =
        header.style && header.style.minWidth ? parseInt(header.style.minWidth.replace('rem', '')) * 1.5 : 15
      worksheet.getColumn(index + 1).width = width
    })
  }

  // Define a helper function to apply styles to cells
  const applyCellStyles = () => {
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
      })
    })
  }

  // Add table header row
  const headerRow = worksheet.addRow(headers.map((header) => header.header))
  headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } } // White bold text
  headerRow.alignment = { vertical: 'middle', horizontal: 'center' }
  headerRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: '000000' }, // Black background color
  }
  rowIndex++

  // Add data rows
  attendanceData.studentAttendanceData.forEach((student) => {
    const rowData = headers.map((header) => {
      if (header.field.includes('-')) {
        // Handle dynamic date fields
        const attendanceRecord = student.student_attendance.find((record) => record.date === header.field)
        return attendanceRecord ? attendanceRecord.attendance : ''
      }
      return student[header.field]
    })
    const dataRow = worksheet.addRow(rowData)
    dataRow.alignment = { vertical: 'middle', horizontal: 'center' }
    rowIndex++
  })

  // Set column widths
  setColumnWidths()

  // Apply styles to all cells
  applyCellStyles()

  // Generate Excel file and prompt download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/octet-stream' })
    saveAs(blob, fileName)
  })
}

export const convertToDate = (dateStr) => {
  const date = new Date(dateStr)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
  const year = date.getFullYear()
  return `${day}-${month}-${year}`
}

export const convertToDateWithoutYear = (dateStr) => {
  const date = new Date(dateStr)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
  const year = date.getFullYear()
  return `${day}-${month}`
}

export const paymentDetailsToExcel = (
  paymentDetails,
  totalPaidAmount,
  sheetName = 'Payment Details',
  fileName = 'Payment_Details_Report.xlsx',
) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  // Define headers
  const headers = [
    { header: 'No', key: 'no', width: 10 },
    { header: 'Collection Date', key: 'collectionDate', width: 25 },
    { header: 'Course Name', key: 'courseName', width: 30 },
    { header: 'Course Code', key: 'courseCode', width: 20 },
    { header: 'Student Name', key: 'studentName', width: 30 },
    { header: 'Receipt No', key: 'receiptNo', width: 25 },
    { header: 'Payment Mode', key: 'paymentMode', width: 20 },
    { header: 'Paid Amount', key: 'paidAmount', width: 20 },
  ]

  worksheet.columns = headers
  const headerRow = worksheet.getRow(1)
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFF' } }
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    cell.border = {
      top: { style: 'thin', color: { argb: 'FFFFFF' } },
      left: { style: 'thin', color: { argb: 'FFFFFF' } },
      bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
      right: { style: 'thin', color: { argb: 'FFFFFF' } },
    }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '999999' }, // Black background
    }
  })

  // Add data rows
  paymentDetails.forEach((payment, index) => {
    const rowData = {
      no: index + 1,
      collectionDate: convertToDate(payment.collectionDate),
      courseName: payment.courseName,
      courseCode: payment.courseCode,
      studentName: payment.studentName,
      receiptNo: payment.receiptNo,
      paymentMode: payment.paymentMode,
      paidAmount: payment.paidAmount,
    }
    worksheet.addRow(rowData)
  })

  // Add footer row with total
  const footerRow = worksheet.addRow([])
  footerRow.getCell(1).value = 'Total'
  footerRow.getCell(1).font = { bold: true }
  footerRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }

  // Merge cells for colspan
  worksheet.mergeCells(footerRow.number, 1, footerRow.number, headers.length - 1)
  footerRow.getCell(headers.length).value = totalPaidAmount
  footerRow.getCell(headers.length).font = { bold: true }
  footerRow.getCell(headers.length).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }

  // Apply padding to each cell (workaround by adding spaces)
  worksheet.eachRow((row, rowNumber) => {
    row.eachCell((cell, colNumber) => {
      cell.value = ` ${cell.value} `
    })
  })

  // Generate Excel file and prompt download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/octet-stream' })
    saveAs(blob, fileName)
  })
}

export const dueFeesDetailsToExcel = (
  dueFeesDetails,
  totalPaidAmount,
  sheetName = 'Due fess Details',
  fileName = 'Due_fess_Report.xlsx',
) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  // Define headers
  const headers = [
    { header: 'No', key: 'no', width: 10 },
    { header: 'student Name', key: 'studentName', width: 25 },
    { header: 'Phone', key: 'phone', width: 30 },
    { header: 'Due Date', key: 'paymentDue', width: 20 },
    { header: 'Branch', key: 'branchName', width: 30 },
    { header: 'Batch', key: 'batchNo', width: 25 },
    { header: 'Course Name', key: 'courseName', width: 20 },
    { header: 'Due Amount', key: 'dueAmount', width: 20 },
    { header: 'Total Fees', key: 'totalFees', width: 20 },
  ]

  worksheet.columns = headers
  const headerRow = worksheet.getRow(1)
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFF' } }
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    cell.border = {
      top: { style: 'thin', color: { argb: 'FFFFFF' } },
      left: { style: 'thin', color: { argb: 'FFFFFF' } },
      bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
      right: { style: 'thin', color: { argb: 'FFFFFF' } },
    }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '999999' }, // Black background
    }
  })

  // Add data rows
  dueFeesDetails.forEach((payment, index) => {
    const rowData = {
      no: index + 1,
      studentName: payment.studentName,
      phone: payment.phone,
      paymentDue: payment.paymentDue,
      branchName: payment.branchName,
      batchNo: payment.batchNo,
      courseName: payment.courseName,
      dueAmount: payment.dueAmount,
      totalFees: payment.totalFees,
    }
    worksheet.addRow(rowData)
  })

  // Add footer row with total
  const footerRow = worksheet.addRow([])
  footerRow.getCell(1).value = 'Total'
  footerRow.getCell(1).font = { bold: true }
  footerRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }

  // Merge cells for colspan
  worksheet.mergeCells(footerRow.number, 1, footerRow.number, headers.length - 1)
  footerRow.getCell(headers.length).value = totalPaidAmount
  footerRow.getCell(headers.length).font = { bold: true }
  footerRow.getCell(headers.length).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }

  // Apply padding to each cell (workaround by adding spaces)
  worksheet.eachRow((row, rowNumber) => {
    row.eachCell((cell, colNumber) => {
      cell.value = ` ${cell.value} `
    })
  })

  // Generate Excel file and prompt download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], { type: 'application/octet-stream' })
    saveAs(blob, fileName)
  })
}

export function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return `${minutes}: ${Math.round(remainingSeconds)}`
}

function numberWithCommas(x) {
  x = parseFloat(x).toFixed(2)
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const downloadReceipt = async (courseDetails, StudentName, dueDetails) => {
  const doc = new jsPDF()

  const paymentDate = courseDetails?.paymentOn ? convertDateFormat(courseDetails?.paymentOn) : ''
  const paymentDueDate = courseDetails?.paymentDue ? convertDateFormat(courseDetails?.paymentDue) : ''
  let remainingDueFees = ``
  dueDetails?.forEach((val) => {
    remainingDueFees += `<tr>
    <td colspan="2" style="border-bottom:none; border-top:none">Rs. ${numberWithCommas(val?.payment)} ${convertDateFormat(val?.paymentDue)}</td>
  </tr>`
  })
  const dueFessDate = courseDetails?.totalDueFees !== 0 ? remainingDueFees : ''
  const receiptNo = dayjs(courseDetails?.createdAt).unix()
  let totalFees =
    courseDetails?.type === 'Registration' ? Number(courseDetails?.registrationAmount) : Number(courseDetails?.payment)
  let taxableAmount = (totalFees / (1 + 18 / 100)).toFixed(2)
  let cgst = ((totalFees - taxableAmount) / 2).toFixed(2)
  let sgst = ((totalFees - taxableAmount) / 2).toFixed(2)
  const htmlContent = `
  <html>
    <body>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 20px;
          background-color: #f0f0f0;
        }
        .receipt {
          max-width: 800px;
          margin: 0 auto;
          background-color: white;
          border: 2px solid #000;
          padding: 20px;
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;  
          margin-bottom: 10px;
        }
        .header h1{
          font-size:17px;
          width:15%;
        }
        .logo {
          margin-top:15px;
          width: 90px;
          height: 90px;
          width:15%;
          clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
        }
        .logo img{
          width: 110px;
          height: 110px;
        }
        .company-info {
          text-align: center;
        }
        .company-name {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .address{
          font-size: 13px;
        }
        .fees-receipt-tag h2{
          margin: 0px;
        }
        .fees-receipt-tag p{
          margin: 0px;
        }
        .receipt-details {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 10px;
          margin-bottom: 20px;
        }
        .table-layout {
          border: 1px solid black;
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          border: 1px solid black;
          padding: 3px 3px 3px 10px;
        }
        th {
          background-color: #f0f0f0;
          align-items: center;
        }
        .bold {
          font-weight: 100%;
        }
        .signature-box {
          border: 1px solid black;
          display: flex;
          align-items: center;
          flex-direction: column;
          /*justify-content: end;*/
          /*height: 100%;*/
        }
        .signature {
          border: 1px solid black;
          border-left: none;
          border-right: none;
          width: 100%;
          height: 50px;
          border-top: none;
        }
        .signature-box{
          border-right: none;
          border-bottom: none;
        }
        .signature-parent-div {
          display: flex;
          justify-content: space-between;
          border: 1px solid black;
          border-top: none;
          padding: 0 0 0 5px;
        }
        .signature-right {
          width: 35%;
          margin-top: 20px;
          display: flex;
          align-items: end;
          justify-content: end;
        }
        .signature-left p{
          margin-top:2px;
        }
        .page-break {
          page-break-before: always;
        }
        .signature-main{
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .gst-table{
          border-collapse: collapse;
        }
        .gst-header th{
          background-color: white;
          color: black;
        }
        .gst-head{
          text-align: left;
          font-size: 12px;
        }
      </style>

  <div style="page-break-before: always;"></div>
      <div class="receipt">
        <div class="header">
          <h1>${courseDetails?.courseName}</h1>
          <div class="company-info">
            <div class="company-name">ACCQUAINT EDUCATION PRIVATE LIMITED</div>
            <p class="address">
              ${courseDetails?.address} <br />
              Contact : ${courseDetails?.branchPhone} E-mail : ${courseDetails?.branchEmail} <br />
              CIN - ${courseDetails?.branchCin || '--'} <br />
              GST No - ${courseDetails?.branchGST || '--'} <br />
              <strong>Receipt Date:</strong> ${paymentDate} <br/>
              <strong>Receipt No:</strong> ${receiptNo}
            </p>
          </div>
          <div class="logo">
            <img src="${AdminLogo}" />
          </div>
        </div>
        <div class="fees-receipt-tag">
          <h2 style="text-align: center">Fees Receipt</h2>
          <p style="text-align: center">Original</p><br />
        </div>
        <div class="receipt-details">
          <div>
            <p><strong>Branch:</strong> ${courseDetails?.branchName}</p>
          </div>
          <div>
            <p><strong>Batch:</strong>${courseDetails?.batchNo}</p>
          </div>
          <div>
            <p><strong>Payment Mode:</strong> ${courseDetails?.type == 'Registration' ? courseDetails?.regPaymentMode : courseDetails?.paymentMode}</p>
          </div>
        </div>
        <table class="table-layout" style="border-collapse: collapse; width: 100%;">
          <tr>
            <th colspan="2">Particulars</th>
            <th>Amounts</th>
          </tr>
          <tr>
            <td colspan="2" class="bold" style="border-bottom:none; border-top:none">
              Student Name: ${StudentName}
            </td>
          </tr>
          <tr>
            <td class="bold" colspan="2" style="border-bottom:none; border-top:none">${courseDetails?.type === 'Registration' ? 'Registration Fees' : courseDetails?.installmentNo}</td>
            <td colspan="2" style="border: none; text-align: right;">Rs. ${courseDetails?.type === 'Registration' ? numberWithCommas(courseDetails?.registrationAmount) : numberWithCommas(courseDetails?.payment)}</td>
          </tr>
          <tr>
            <td class="bold" colspan="2" style="border-bottom:none; border-top:none">Total Fees Due: Rs. ${numberWithCommas(courseDetails?.totalDueFees)}</td>
          </tr>
          ${dueFessDate}
          <tr>
            <td style="border-bottom:none; border-top:none; text-align: right; "></td>
            <td colspan="2" style="text-align: right;">
              <p>Rs. ${courseDetails?.type === 'Registration' ? numberWithCommas(courseDetails?.registrationAmount) : numberWithCommas(courseDetails?.payment)}</p>
            </td>
          </tr>
        </table>
        <div class="signature-parent-div">
        <div class="signature-main">
          <div class="signature-left">
            <p class="bold">Amount (in words):</p>
            <p>${courseDetails?.type === 'Registration' ? courseDetails?.registrationAmountInWord : courseDetails?.paymentInWords}</p>
          </div>
          <div>
          <table class="gst-table">
          <thead class="gst-header">
            <tr>
              <th class="gst-head">SAC Code</th>
              <th class="gst-head">Taxable Amount</th>
              <th class="gst-head">CGST</th>
              <th class="gst-head">SGST</th>
              <th class="gst-head">Total Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="gst-head">9992</td>
              <td class="gst-head">${numberWithCommas(taxableAmount)}</td>
              <td class="gst-head">${numberWithCommas(cgst)}</td>
              <td class="gst-head">${numberWithCommas(sgst)}</td>
              <td class="gst-head">${courseDetails?.type === 'Registration' ? numberWithCommas(courseDetails?.registrationAmount) : numberWithCommas(courseDetails?.payment)}</td>
            </tr>
          </tbody>
        </table>        
          </div>
        </div>
          <div class="signature-right">
            <div class="signature-box">
              <div class="signature"></div>
              <div class="Auth-sign"><b>Authorized Signatory</b></div>
            </div>
          </div>
        </div>
      </div>
    
    </body>
  </html>
`
  const htmlContentDuplicate = `
  <html>
  <body>
    <style>
      body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 20px;
        background-color: #f0f0f0;
      }
      .receipt {
        max-width: 800px;
        margin: 0 auto;
        background-color: white;
        border: 2px solid #000;
        padding: 20px;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;  
        margin-bottom: 10px;
      }
      .header h1{
        font-size:17px;
        width:15%;
      }
      .logo {
        margin-top:15px;
        width: 90px;
        height: 90px;
        width:15%;
        clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
      }
      .logo img{
        width: 110px;
        height: 110px;
      }
      .company-info {
        text-align: center;
      }
      .company-name {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .address{
        font-size: 13px;
      }
      .fees-receipt-tag h2{
        margin: 0px;
      }
      .fees-receipt-tag p{
        margin: 0px;
      }
      .receipt-details {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        margin-bottom: 20px;
      }
      .table-layout {
        border: 1px solid black;
        width: 100%;
        border-collapse: collapse;
      }
      th, td {
        border: 1px solid black;
        padding: 3px 3px 3px 10px;
      }
      th {
        background-color: #f0f0f0;
        align-items: center;
      }
      .bold {
        font-weight: 100%;
      }
      .signature-box {
        border: 1px solid black;
        display: flex;
        align-items: center;
        flex-direction: column;
        /*justify-content: end;*/
        /*height: 100%;*/
      }
      .signature {
        border: 1px solid black;
        border-left: none;
        border-right: none;
        width: 100%;
        height: 50px;
        border-top: none;
      }
      .signature-box{
        border-right: none;
        border-bottom: none;
      }
      .signature-parent-div {
        display: flex;
        justify-content: space-between;
        border: 1px solid black;
        border-top: none;
        padding: 0 0 0 5px;
      }
      .signature-right {
        width: 35%;
        margin-top: 20px;
        display: flex;
        align-items: end;
        justify-content: end;
      }
      .signature-left p{
        margin-top:2px;
      }
      .page-break {
        page-break-before: always;
      }
      .signature-main{
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      .gst-table{
        border-collapse: collapse;
      }
      .gst-header th{
        background-color: white;
        color: black;
      }
      .gst-head{
        text-align: left;
        font-size: 12px;
      }
    </style>

<div style="page-break-before: always;"></div>
    <div class="receipt">
      <div class="header">
        <h1>${courseDetails?.courseName}</h1>
        <div class="company-info">
          <div class="company-name">ACCQUAINT EDUCATION PRIVATE LIMITED</div>
          <p class="address">
            ${courseDetails?.address} <br />
            Contact : ${courseDetails?.branchPhone} E-mail : ${courseDetails?.branchEmail} <br />
            CIN - ${courseDetails?.branchCin || '--'} <br />
            GST No - ${courseDetails?.branchGST || '--'} <br />
            <strong>Receipt Date:</strong> ${paymentDate} <br/>
            <strong>Receipt No:</strong> ${receiptNo}
          </p>
        </div>
        <div class="logo">
          <img src="${AdminLogo}" />
        </div>
      </div>
      <div class="fees-receipt-tag">
        <h2 style="text-align: center">Fees Receipt</h2>
        <p style="text-align: center">Duplicate</p><br />
      </div>
      <div class="receipt-details">
        <div>
          <p><strong>Branch:</strong> ${courseDetails?.branchName}</p>
        </div>
        <div>
          <p><strong>Batch:</strong>${courseDetails?.batchNo}</p>
        </div>
        <div>
          <p><strong>Payment Mode:</strong> ${courseDetails?.type == 'Registration' ? courseDetails?.regPaymentMode : courseDetails?.paymentMode}</p>
        </div>
      </div>
      <table class="table-layout" style="border-collapse: collapse; width: 100%;">
          <tr>
            <th colspan="2">Particulars</th>
            <th>Amounts</th>
          </tr>
          <tr>
            <td colspan="2" class="bold" style="border-bottom:none; border-top:none">
              Student Name: ${StudentName}
            </td>
          </tr>
          <tr>
            <td class="bold" colspan="2" style="border-bottom:none; border-top:none">${courseDetails?.type === 'Registration' ? 'Registration Fees' : courseDetails?.installmentNo}</td>
            <td colspan="2" style="border: none; text-align: right;">Rs. ${courseDetails?.type === 'Registration' ? numberWithCommas(courseDetails?.registrationAmount) : numberWithCommas(courseDetails?.payment)}</td>
          </tr>
          <tr>
            <td class="bold" colspan="2" style="border-bottom:none; border-top:none">Total Fees Due: Rs. ${numberWithCommas(courseDetails?.totalDueFees)}</td>
          </tr>
          ${dueFessDate}
          <tr>
            <td style="border-bottom:none; border-top:none; text-align: right; "></td>
            <td colspan="2" style="text-align: right;">
              <p>Rs. ${courseDetails?.type === 'Registration' ? numberWithCommas(courseDetails?.registrationAmount) : numberWithCommas(courseDetails?.payment)}</p>
            </td>
          </tr>
        </table>
        <div class="signature-parent-div">
        <div class="signature-main">
          <div class="signature-left">
            <p class="bold">Amount (in words):</p>
            <p>${courseDetails?.type === 'Registration' ? courseDetails?.registrationAmountInWord : courseDetails?.paymentInWords}</p>
          </div>
          <div>
          <table class="gst-table">
          <thead class="gst-header">
            <tr>
              <th class="gst-head">SAC Code</th>
              <th class="gst-head">Taxable Amount</th>
              <th class="gst-head">CGST</th>
              <th class="gst-head">SGST</th>
              <th class="gst-head">Total Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="gst-head">9992</td>
              <td class="gst-head">${numberWithCommas(taxableAmount)}</td>
              <td class="gst-head">${numberWithCommas(cgst)}</td>
              <td class="gst-head">${numberWithCommas(sgst)}</td>
              <td class="gst-head">${courseDetails?.type === 'Registration' ? numberWithCommas(courseDetails?.registrationAmount) : numberWithCommas(courseDetails?.payment)}</td>
            </tr>
          </tbody>
        </table>        
        </div>
      </div>
        <div class="signature-right">
          <div class="signature-box">
            <div class="signature"></div>
            <div class="Auth-sign"><b>Authorized Signatory</b></div>
          </div>
        </div>
      </div>
    </div>
  
  </body>
</html>
`

  await doc.html(htmlContentDuplicate, {
    x: 10,
    y: 10,
    width: 190,
    windowWidth: 675,
  })

  doc.insertPage(1)

  await doc.html(htmlContent, {
    x: 10,
    y: 10,
    width: 190,
    windowWidth: 675,
  })

  // Save the PDF
  doc.save(`receipt_${courseDetails.studentPaymentId}.pdf`)
}

export const generateCSVBlob = (data, columns) => {
  const csvRows = []

  // Add column headers
  const headers = columns.map((col) => col.header)
  csvRows.push(headers.join(','))

  // Add data rows
  data.forEach((row) => {
    const rowData = columns.map((col) => row[col.field] || '') // Use the field to get values
    csvRows.push(rowData.join(','))
  })

  // Create Blob from CSV content
  const csvContent = csvRows.join('\n')
  return new Blob([csvContent], { type: 'text/csv' })
}
